<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script></script>
<style lang="scss">
#app {
    min-height: 100vh;
    font-family: 'Lato', 'Noto Sans TC';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $gray2;
    line-height: 1.5em;
    letter-spacing: 0.05em;
    overflow: inherit;
    height: 100%;

    @media screen and (min-width: 768px) {
        min-width: 960px;
    }
}
</style>
